// 文言（ui/lang/*.json の CREATE_T）（2026-10-21 に app.js から分けた）

// ---- 文言 ----
// index.php が言語ごとの辞書（lang/{言語}.json。訳の無いものは英語、英語にも無ければ日本語）を window.CREATE_T に入れる。
// txt('キー', { n: 3 }) で {n} などを置きかえる。HTML に入れるときは txtHtml
// モックの確認用のもの（ロゴのメニュー・読み込みの状態・控えに戻す）は本物に入れないので、日本語のまま
export const TEXT: Record<string, string> = window.CREATE_T || {};
export const LANG = document.documentElement.lang || 'ja';
export function txt(key: string, vars?: Record<string, string | number>): string {
  let s = TEXT[key] != null ? String(TEXT[key]) : key;
  if (vars) s = s.replace(/\{(\w+)\}/g, (m, k) => vars[k] != null ? String(vars[k]) : m);
  return s;
}
export function escHtml(s: unknown): string { return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' } as Record<string, string>)[c]); }
export function txtHtml(key: string, vars?: Record<string, string | number>): string { return escHtml(txt(key, vars)); }
// カテゴリの見出し（今の画面はアイコンだけで名前が無いので、モックで付けた名前。辞書の cat.{キー}）と、列に出す短い名前（short.{キー}、無ければ見出し）
// メーカーごとの名前（設定 catLabels。DRESSUP2 の cloak → outer など。同じキーでもメーカーで中身が違うため）
const CAT_LABELS: Record<string, string> = (window.CREATE_CONFIG && window.CREATE_CONFIG.catLabels) || {};
export function catLabel(key: string): string { const k = CAT_LABELS[key] || key; return TEXT['cat.' + k] || TEXT['cat.' + key] || key; }
export function catShort(key: string): string { const k = CAT_LABELS[key] || key; return TEXT['short.' + k] || (CAT_LABELS[key] ? '' : TEXT['short.' + key]) || catLabel(key); }
